import { render, staticRenderFns } from "./AddLiveAccount.vue?vue&type=template&id=8e063d2a"
import script from "./AddLiveAccount.vue?vue&type=script&lang=js"
export * from "./AddLiveAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports